import * as customer from './segments/customer';
import * as decision from './segments/decision';
import * as parent from './AppParentComponent';
import * as horizontalRule from './HorizontalRule';
import * as validations from './utils';
import * as formfeedback from './FormFeedbackHook';
import * as iconsecuritysecure from './IconSecuritySecureHook';
export default {
  decision,
  customer,
  parent,
  horizontalRule,
  validations,
  formfeedback,
  iconsecuritysecure,
};
